import styled from '@emotion/styled';
import { H1, SmallText, Text } from 'ds/components/typography';

export const Content = styled.div`
  width: 576px;
  margin: 0 auto;
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    width: auto;
    max-width: 576px;
  `}
`;

export const Title = styled(Text)`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  font-weight: 700;
`;

export const Section = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(3)};
  padding: ${({ theme }) => `${theme.spacing(3)} 0`};
  border-bottom: 1px dashed #d3d3d3;
  &:last-of-type {
    padding-bottom: 0;
    border-bottom: 0 none;
  }
`;

export const SectionIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SectionInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const NameWrapper = styled(Text)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)};
  color: ${({ theme }) => theme.colors.neutrals.grey2};
`;

export const Value = styled(H1.withComponent('div'))`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.brand.main};
  font-weight: 700;
`;

export const Qmark = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  border-radius: ${({ theme }) => theme.borderRadius.round};
  background-color: ${({ theme }) => theme.colors.neutrals.grey6};
  &:after {
    content: '?';
    transform: scale(1,0.6) rotate(6deg);
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
  }
`;

export const WeHaveIt = styled.div`
  max-width: 354px;
  margin: 0 auto;
`;

export const WeHaveTitle = styled.div`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  text-align: center;
  font-size: 17px;
  font-weight: 700;
  line-height: 22px;
`;

export const WeHaveText = styled(SmallText)`
  color: ${({ theme }) => theme.colors.neutrals.grey3};
  text-align: center;
`;
